import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleWithDot = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.352 2.352L0.968 2.968C0.86 3.292 0.8 3.64 0.8 4C0.8 5.764 2.236 7.2 4 7.2C5.764 7.2 7.2 5.764 7.2 4C7.2 2.236 5.764 0.8 4 0.8C3.64 0.8 3.292 0.86 2.968 0.968L2.356 0.356C2.86 0.128 3.416 0 4 0C6.208 0 8 1.792 8 4C8 6.208 6.208 8 4 8C1.792 8 0 6.208 0 4C0 3.412 0.128 2.856 0.352 2.352ZM1.6 4C1.6 2.676 2.676 1.6 4 1.6C5.324 1.6 6.4 2.676 6.4 4C6.4 5.324 5.324 6.4 4 6.4C2.676 6.4 1.6 5.324 1.6 4ZM2 1.4C2 1.732 1.732 2 1.4 2C1.068 2 0.8 1.732 0.8 1.4C0.8 1.068 1.068 0.8 1.4 0.8C1.732 0.8 2 1.068 2 1.4Z",
		fill: "#EDB902"
	})
});
export default SvgCircleWithDot;
